import { MANUAL_ACCESS_VOCABULARIES } from './manual-access.js';
/** Slice d597 of the catalog (D577): the vocabularies the platform manual's access control (D597) brought. */
export const SLICE_D597 = [...MANUAL_ACCESS_VOCABULARIES];
//# sourceMappingURL=slice-d597.js.map